import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "@/i18n/index"
import store from "./store";
import SnackbarPlugin from "./plugins/snackbar";
// import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import vuetify from "./plugins/vuetify";
import VueMask from "v-mask";
import "./assets/styles/_main.scss";

Vue.use(SnackbarPlugin);
Vue.use(VueMask);
// Vue.use(TiptapVuetifyPlugin, {
//   vuetify,
//   iconsGroup: "mdi",
// });
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
